<template>
  <ul class="flex flex-wrap gap-8">
    <li
      v-for="country in countries"
      :key="country.name.id"
      class="rounded-full flex items-center gap-8 bg-[white]/50 p-2 pe-8"
    >
      <span class="raw-body-2 rounded-full bg-[white] px-8 py-4">
        {{
          i18n.number(country.percent / 100, {
            style: 'percent',
            maximumFractionDigits: 2,
          })
        }}
      </span>
      <span class="raw-body-3 line-clamp-1">{{ i18n(country.name) }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

defineProps<{
  countries: { name: I18nDescriptor; percent: number }[]
}>()

const i18n = useI18n()
</script>
